<template>
  <SimpleCrud
    :headers="headers"
    :name="rq_name"
    :canWrite="false"
    :canDetail="false"
    :canAdd="false"
    :canDelete="false">
    <template v-slot:material_number="{ value }">
      <fs1 tag="td" class="text_align_left">{{j(value,', ')  || 'No identificado'}}</fs1>
    </template>
    <template v-slot:spare_part_type="{ value }">
      <fs1 tag="td">{{value || 'N/A'}}</fs1>
    </template>
  </SimpleCrud>
</template>
<script>
import filter from '@/components/mixins/filter';
export default {
  props:['type','ex_filters'],
  mixins:[filter],
  computed: {
    name() { return /* this.type == 'simulations'? 'reported_action/simulate' : */ 'spare_part'},
    rq_name(){ return `${this.type}-${this.name}`},
    headers() {
			return [
        { text: 'Repuesto', value: 'name', class:['text_align_left'] },
        { text: 'Material Number', value: 'material_number', class:['text_align_left'] },
        { text: 'Modo de Falla Catastrófico', value: 'mfl_event', class:['text_align_left'] },
        { text: 'Tipo', value: 'spare_part_type', },
			];
    },
  },
  watch:{
    'ex_filters':{
      deep: true,
      handler(v){ this.get_data() }
    },
  },
  created() {
    this.get_data();
  }, // created
  methods:{
    resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    },
    get_data(){
      if (this.myRequestStatus) this.resetRqStatus();
      Object.assign(this.filter, this.ex_filters);
      const filter = {...this.filter};
      Object.keys(filter).forEach(k => [undefined,null].includes(filter[k]) && (delete filter[k]));
      this.requests.gets[`${this.rq_name}/a/all`](filter);
    }
  }
};
</script>
